import React from 'react';
import PropTypes from 'prop-types';
import icoExtraBalance from '../../../../images/extra-saldo/ico_extra_plata.svg';
import icoExtraData from '../../../../images/extra-saldo/ico_extra_data.svg';
import icoExtraMinutes from '../../../../images/extra-saldo/ico_extra_min.svg';
import {
  ContentWrapperStyled as ContentWrapper,
  CurrentBalanceWrapperStyled as CurrentBalanceWrapper,
  IconCurrentBalanceStyled as IconCurrentBalance,
  ProgressBarStyled as ProgressBar,
} from './styles/CurrentBalanceStyled';
import { Numbers, SizeConversion } from '../../../../helpers';

const CurrentBalance = ({ actualBalance, label }) => {
  const getIconAndData = () => {
    switch (label) {
      case 'SALDO': {
        const icon = icoExtraBalance;
        const remaining = Numbers.addThousandSeparators(
          actualBalance.balance.total
        );
        return { icon, remaining };
      }
      case 'DATOS': {
        const { value } = actualBalance.graphics.data;
        const icon = icoExtraData;
        const remaining = SizeConversion.formatAmount(
          value.balance,
          value.unity
        );
        const initialBalance = SizeConversion.formatAmount(
          value.initialBalance,
          value.unity
        );
        return { icon, remaining, initialBalance };
      }
      default: {
        const { value: minutesValue } = actualBalance.graphics.minutes;
        const icon = icoExtraMinutes;
        const remaining = SizeConversion.formatAmount(
          minutesValue.balance,
          minutesValue.unity
        );
        const initialBalance = SizeConversion.formatAmount(
          minutesValue.initialBalance,
          minutesValue.unity
        );
        return { icon, remaining, initialBalance };
      }
    }
  };

  const { icon, remaining, initialBalance } = getIconAndData();

  const hasProgressBar = typeof remaining === 'object';

  return (
    <CurrentBalanceWrapper hasProgressBar={hasProgressBar}>
      <IconCurrentBalance src={icon} alt={`${label}-icon`} />
      <ContentWrapper hasProgressBar={hasProgressBar}>
        {hasProgressBar ? (
          <>
            <h4>{`Te quedan ${remaining.size} ${remaining.unit}`}</h4>
            <ProgressBar
              className="custom-progress"
              progress={
                initialBalance.size === 0
                  ? 0
                  : (remaining.size / initialBalance.size) * 100
              }
            />
          </>
        ) : (
          <h4>{`Te quedan $${remaining}`}</h4>
        )}
      </ContentWrapper>
    </CurrentBalanceWrapper>
  );
};

CurrentBalance.propTypes = {
  actualBalance: PropTypes.objectOf(PropTypes.shape).isRequired,
  label: PropTypes.string.isRequired,
};

export default CurrentBalance;
